import { render, staticRenderFns } from "./TodoEdit.vue?vue&type=template&id=3d3df94b&"
import script from "./TodoEdit.vue?vue&type=script&lang=js&"
export * from "./TodoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports